import { OverflowTooltip } from '@/components/common/overflow-tooltip';

import styles from './cells.module.scss';

export function textCell(value: string) {
  return (
    <OverflowTooltip title={value}>
      <span className={styles.text}>{value}</span>
    </OverflowTooltip>
  );
}
